<template>
  <b-modal
    :id="modalId"
    visible
    size="xl"
    centered
    hide-footer
    modal-class="requests-modal"
    @hide="$emit('close')"
  >
    <template #modal-header>
      <div class="requests-modal-header">
        <div class="header-left">
          <div class="header-avatar">
            <feather-icon
              icon="FileTextIcon"
              size="24"
            />
          </div>
          <div class="header-text">
            <h4 class="header-title">
              {{ userData.name }} — Requests
            </h4>
            <span class="header-subtitle">
              Engineer requests analysis
            </span>
          </div>
        </div>
        <div
          class="close-btn"
          @click="$emit('close')"
        >
          <feather-icon
            icon="XIcon"
            size="20"
          />
        </div>
      </div>
    </template>

    <div
      v-if="isLoading"
      class="loading-wrapper"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Loading"
      />
      <span class="loading-text">Loading requests...</span>
    </div>
    <TableControl
      v-else
      :data-table="getDataTable"
    />
  </b-modal>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'
import TableControl from './TableControl.vue'

export default {
  components: { TableControl },
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalId: 'engineer-info-modal-request',
      getDataTable: {},
      isLoading: false,
    }
  },
  watch: {
    'userData.userID': function handleUserChange(newVal) {
      if (newVal) {
        this.getUserRequests(newVal)
      }
    },
  },
  mounted() {
    if (this.userData?.userID) {
      this.getUserRequests(this.userData.userID)
    }
  },
  methods: {
    getUserRequests(userId) {
      this.isLoading = true
      axios
        .get(`/engineer-requests-analysis?engineer_id=${userId}`)
        .then(res => {
          this.getDataTable = decryptData(res.data.payload).data || {}
        })
        .catch(() => {
          this.getDataTable = {}
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.requests-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 0.5rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #5e5873;
  margin: 0;
}

.header-subtitle {
  font-size: 0.85rem;
  color: #b9b9c3;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b9b9c3;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    color: #5e5873;
  }
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  gap: 1rem;
}

.loading-text {
  font-size: 0.95rem;
  color: #b9b9c3;
}
</style>

<style lang="scss">
.requests-modal .modal-header {
  background: linear-gradient(135deg, #f8f7ff 0%, #fff 100%);
  border-bottom: 1px solid #ebe9f1;
  padding: 1.25rem 1.5rem;
}

.requests-modal .modal-body {
  padding: 1.5rem;
  overflow: visible;
}

.requests-modal .modal-dialog {
  max-width: 95vw;
}
</style>
